
















import { Component, Vue, Prop } from "vue-property-decorator";
import { ATMAsset } from "@foxone/api/src/models/market";
import { CONFIGS } from "@/constants";

@Component
class Introduction extends Vue {
  @Prop() estimated!: string;

  @Prop() wanted!: ATMAsset | "";

  get hint() {
    if (!this.wanted || !this.estimated) return "";
    return this.$t("trade.estimated", {
      amount: `${this.estimated} ${this.wanted.symbol}`
    });
  }

  handleToSwap() {
    window.location.href = CONFIGS.SWAP_URL;
  }
}
export default Introduction;
